export function openChannelFromUrl(
    url: string,
    param: string,
    id?: string
): string | undefined {
    if (url.includes(param)) {
        const queryString = url.split('?')[1]

        if (queryString && id) {
            const params = new URLSearchParams(queryString)
            const contentId = params.get(id)
            if (contentId) {
                return contentId
            }
        } else {
            return param
        }
    }
    return undefined
}
